/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import Icon from '@salesforce/design-system-react/components/icon';
import IconSettings from '@salesforce/design-system-react/components/icon-settings';

// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faChevronUp, faChevronDown } from '@fortawesome/fontawesome-free-solid';
interface Props {
  open?: boolean;
  title: string;
  handleFilterOpening: (title: any) => void;
}

const Collapsible: React.FC<Props> = ({ open, children, title, handleFilterOpening }) => {
  // const [isOpen, setIsOpen] = useState(open);

  // const handleFilterOpening = (): void => {
  //   setIsOpen(prev => !prev);
  // };

  return (
    <IconSettings iconPath="/icons">
      <div className="card" style={{ marginBottom: '20px', border: '1px solid #dbdada' }}>
        {/* <div> */}
        <div
          // className=""
          style={{
            display: 'inline-block',
            width: '100%',
            background: '#dbdada',
            padding: '10px',
          }}
        >
          <span
            aria-hidden="true"
            role="button"
            onClick={(): void => handleFilterOpening(title)}
            style={{ cursor: 'pointer' }}
          >
            {!open ? (
              <Icon
                assistiveText={{ label: 'Announcement' }}
                category="utility"
                name="chevronright"
                size="x-small"
                style={{ fill: '#000', display: 'inline-block' }}
              />
            ) : (
              <Icon
                assistiveText={{ label: 'Announcement' }}
                category="utility"
                name="chevrondown"
                size="x-small"
                style={{ fill: '#000', display: 'inline-block' }}
              />
            )}
          </span>
          <span
            style={{
              display: 'inline-block',
              marginLeft: '5px',
              fontSize: '16px',
              fontWeight: 600,
            }}
          >
            {title}
          </span>
        </div>
        {/* </div> */}

        <div className="border-bottom">
          <div>
            {open && (
              <div className="p-3" style={{ padding: '10px' }}>
                {children}
              </div>
            )}
          </div>
        </div>
      </div>
    </IconSettings>
  );
};

export default Collapsible;
